import { render, staticRenderFns } from "./6_diseaseTime.vue?vue&type=template&id=56115787&scoped=true&"
import script from "./6_diseaseTime.vue?vue&type=script&lang=js&"
export * from "./6_diseaseTime.vue?vue&type=script&lang=js&"
import style0 from "./6_diseaseTime.vue?vue&type=style&index=0&id=56115787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56115787",
  null
  
)

export default component.exports